// src/utils/acl.js
import { computed } from 'vue';
import { useStore } from 'vuex';

// Common mapping of route paths to required ACL permissions (view-level only)
export const routePermissionMap = {
  '/dashboard': null, // No ACL required for dashboard
  '/service-flows': 'service_flows_view',
  '/documents': 'documents_view',
  '/notifications': 'notifications_view',
  '/approvals': 'approvals_view',
  '/customers': 'customers_view',
  '/feedbacks': 'feedbacks_view',
  '/tickets': 'tickets_view',
  '/services': 'services_view',
  '/service-flow-templates': 'service_flow_templates_view',
  '/roles': 'roles_view',
  '/users': 'users_view',
  '/user-roles': 'user_roles_view',
  '/permissions': 'permissions_view',
  '/document-types': 'document_types_view',
  '/modules': 'modules_view',
  '/module-helps': 'module_helps_view',
  '/activity-logs': 'activity_logs_view',
  '/integrations': 'integrations_view',
  '/service-flow-steps': 'service_flow_steps_view',
  '/service-flow-template-steps': 'service_flow_template_steps_view',
  '/service-flow-step-fields': 'service_flow_step_fields_view',
  '/service-flow-step-instances': 'service_flow_step_instances_view',
  '/service-flow-step-field-instances': 'service_flow_step_field_instances_view',
  '/service-flow-template-step-fields': 'service_flow_template_step_field_view',
  '/system-settings': 'system_settings_view',
  '/attendance': 'attendance_page_view',
};

/**
 * useAcl composable for permission checks
 * @param {string} base - base permission string, e.g. 'integration_fields'
 * @returns {object} - { canView, canEdit, canDelete }
 */
export function useAcl(base) {
  const store = useStore();
  const acl = computed(() => store.state.acl || []);

  const canView = computed(() => acl.value.includes(`${base}_view`));
  const canEdit = computed(() => acl.value.includes(`${base}_edit`));
  const canDelete = computed(() => acl.value.includes(`${base}_delete`));

  const userRoles = computed(() => store.state.user?.roles || []);
  const hasRole = (roleName) => userRoles.value.some(r => r.name === roleName);
  const hasAnyRole = (roleNames) => userRoles.value.some(r => roleNames.includes(r.name));

  return { canView, canEdit, canDelete, hasRole, hasAnyRole };
}
